import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import PropTypes from "prop-types";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    marginTop: "1em"
  }
});

const SearchBossTable = props => {
  const classes = useStyles();
  const { search, setSearch, name } = props;

  return (
    <Grid container className={classes.root}>
      <Grid item container xs={12} justify="center">
        <Grid item container xs={6} justify="center">
          <FormControl fullWidth variant="outlined">
            <TextField
              id="outlined-disabled"
              label={`Buscar en ${name}`}
              variant="outlined"
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ backgroundColor: "#fff" }}
            />
          </FormControl>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SearchBossTable;

SearchBossTable.propTypes = {
  search: PropTypes.string,
  setSearch: PropTypes.func,
  name: PropTypes.string
};
